// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3UNa-","text":"SelectPayment_text__3Qgj_","title":"SelectPayment_title__fiIds","btn":"SelectPayment_btn__1qoks"};